module.exports = __webpack_public_path__ + "img/sls1.2610be84.jpg";